import { render, staticRenderFns } from "./MonitoringIndex.vue?vue&type=template&id=4f64a527&scoped=true&"
import script from "./MonitoringIndex.vue?vue&type=script&lang=js&"
export * from "./MonitoringIndex.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringIndex.vue?vue&type=style&index=0&id=4f64a527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64a527",
  null
  
)

export default component.exports